import { HttpBackend, HttpClient, HttpHandler } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Config } from './config';

@Injectable({
    providedIn: 'root',
})
export class ConfigService {
    private readonly configJsonPath = `../assets/config/config.json`;
    public config: Config ;

    constructor(private handler: HttpBackend) { }

    public loadConfigFromJson(): Observable<Config> {
        return new HttpClient(this.handler).get<Config>(this.configJsonPath)
        .pipe(tap(configuration => this.config = configuration));
    }
}
